import SourceFlowForm from '@sourceflow-uk/sourceflowform';
import { Container, Row, Col } from 'reactstrap';
import styles from './styles.module.scss';

export const Form = ({
    content,
    form,
    successPageUrl,
    divider,
    customClass
}) => {

    return (
        <section className={`${styles.root}`}>
            <span className="overlayBg position-absolute">
                <img src={"/site-assets/svg/logo-black.svg"} alt="Branded Logo" />
            </span>
            <Container className="position-relative py-4 py-md-5">
                {divider &&
                    <hr className="pt-5" />
                }
                <Row>
                    <Col md={6} className="pe-md-5 mb-4 mb-md-0">
                        {content &&
                            <div dangerouslySetInnerHTML={{ __html: content }} />
                        }
                    </Col>
                    <Col md={6} className="ps-md-5">
                        <div className={`${customClass} rounded-4 overflow-hidden`}>
                            <SourceFlowForm
                                formId={form}
                                onSubmitDone={() => (window.location.href = `${successPageUrl}`)}
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Form;
